<template>
  <div id="qrPaymentRequest">

    <div class="page-title">{{$t('qr_payment_request.single')}} #{{id}}</div>

    <template v-if="task">
      <Panel :title="$t('items.information')">
        <div class="columns">
          <div class="column">
            <InformationBlock
                :title="$t('qr_payment_request.details')"
                icon="/icon/faq.svg"
                :data="[
              {label: $t('id'), value: task.id },
              {label: $t('action'), value: task.action},
              {label: $t('type'), value: task.type}
            ]"
            />
          </div>
          <div class="column">
            <InformationBlock
                :title="$t('qr_payment_request.time')"
                icon="/icon/clock.svg"
                :data="[
              {label: $t('created_at'), value: task.createdAt },
              {label: $t('completed_at'), value: task.fulfilledAt}
            ]"
            />
          </div>
        </div>
        <Panel collapsible :title="$t('error.title')">
          <json-viewer :value="task.errors" v-if="task.errors"/>
          <span><i>{{$t('no_error')}}</i></span>
        </Panel>
      </Panel>

      <Panel :title="$t('qr_payment_request.payload')" collapsible>
        <json-viewer :value="task.payload"/>
      </Panel>

      <Panel :title="$t('qr_payment_request.response')" collapsible>
        <json-viewer :value="task.response"/>
      </Panel>
    </template>

    <div class="footer-actions">
      <button class="btn btn-primary" @click="back">{{$t('back')}}</button>
    </div>


  </div>
</template>

<script>
import JsonViewer from 'vue-json-viewer'
import InformationBlock from "@/components/tools/InformationBlock";
import {Core} from "@/core/Core";

export default {
  name: "qrPaymentRequest",

  components: { JsonViewer, InformationBlock },

  data() {
    return {
      task: null
    }
  },

  async mounted() {
    this.$store.state.pageTitleTranslationKey = "qr_payment_request.title";
    this.$store.state.pageIcon = "/icon/low-level.svg";

    if (!this.id) {
      return;
    }

    showSpinner();
    await this.getTask();
    hideSpinner();
  },

  computed: {
    id() {
      return this.$route.query.id;
    }
  },

  methods: {
    async getTask() {
      try {
        this.task = await Core.request('GET', '/api/qr_pay_requests/' + this.id);
      } catch (error) {
        hideSpinner();
        console.log("fetch task error", error);
        toast(this.$t('error.request_error'), "error", this.$t("error.title"));
      }
    },
    back() {
      this.$router.push(this.$router.buildContext("/maitre-tasks"));
    }
  }
}
</script>
